import { Fade, Grid } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import React from "react";

import TextFieldWrapper, { MuiTimePicker } from "../../components/TextField";

const RegisterStage2 = () => {
  let [open, setOpen] = React.useState(false);

  React.useLayoutEffect(() => {
    setOpen(true);

    return () => {
      setOpen(false);
    };
  }, []);
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Fade in={open} timeout={500}>
        <Grid
          item
          container
          xl={6}
          lg={6}
          md={9}
          xs={10}
          justifyContent="center"
          spacing={2}
          style={{ margin: "auto" }}
        >
          <Grid item xs={12}>
            <TextFieldWrapper name="board_title" label="نام دفتر" />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper name="office_number" label="شماره دفتر " />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper name="phone" label="شماره ثابت دفتر" />
          </Grid>
          <Grid item xs={12}>
            <MuiTimePicker name="start_work_time" label="ساعت شروع کاری" />
          </Grid>
          <Grid item xs={12}>
            <MuiTimePicker name="end_work_time" label="ساعت پایان کاری" />
          </Grid>
        </Grid>
      </Fade>
    </MuiPickersUtilsProvider>
  );
};

export default RegisterStage2;
